export const dateTimePickerIcons = {
  time: 'fa fa-clock-o',
  date: 'fa fa-calendar',
  up: 'fa fa-chevron-up',
  down: 'fa fa-chevron-down',
  previous: 'fa fa-chevron-left',
  next: 'fa fa-chevron-right',
  today: 'fa fa-screenshot',
  clear: 'fa fa-trash',
  close: 'fa fa-remove',
};

export const findParent = (elm: HTMLElement, possibleParents: HTMLElement[]) => (
  $(possibleParents).filter((i, possibleParent) => $(possibleParent).has(elm).length > 0).first()
);

export const findChild = (elm: HTMLElement | JQuery<HTMLElement>, possibleChildren: HTMLElement[]) => (
  $(possibleChildren).filter((i, possibleChild) => $(elm).has(possibleChild).length > 0).first()
);
